import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OTChargeModel } from '../../models/OTChargeModel'

export interface OTChargeState {
    OTCharge: OTChargeModel
    OTChargeList: OTChargeModel[]
}

const initialState: OTChargeState = {
    OTCharge: {
        Id: 0,
        DepartmentId: 0,
        DepartmentName: '',
        ItemName: '',
        OTCharges: 0,
        OperationCharges: 0,
        SurgeryCharges: 0,
        AnestheticCharges: 0,
        Duration:0
    },
    OTChargeList: [],
}

export const OTChargeSlice = createSlice({
    name: 'otcharge',
    initialState,
    reducers: {
        setOTCharges: (state, action: PayloadAction<OTChargeModel[]>) => {
            state.OTChargeList = action.payload
        },
        saveOTCharge: (state, action: PayloadAction<OTChargeModel>) => {
            let model = action.payload
            if (model.Id > 0) {
                let defaultModel: OTChargeModel = {
                    Id: model.Id,
                    DepartmentId: model.DepartmentId,
                    DepartmentName: model.DepartmentName,
                    ItemName: model.ItemName,
                    OTCharges : model.OTCharges,
                    OperationCharges: model.OperationCharges,
                    SurgeryCharges: model.SurgeryCharges,
                    AnestheticCharges: model.AnestheticCharges,
                    Duration: model.Duration
                }
                let currentModel = state.OTChargeList.find((c) => c.Id === model.Id) || defaultModel
                currentModel.DepartmentId = model.DepartmentId
                currentModel.DepartmentName = model.DepartmentName
                currentModel.ItemName = model.ItemName
                currentModel.OTCharges = model.OTCharges
                currentModel.OperationCharges= model.OperationCharges
                currentModel.SurgeryCharges = model.SurgeryCharges
                currentModel.AnestheticCharges = model.AnestheticCharges
                currentModel.Duration = model.Duration
            } else {
                model.Id = (Math.max(...state.OTChargeList.map((c) => c.Id)) || 0) + 1
                state.OTChargeList.push(model)
            }
        },
        getOTChargeById: (state, action: PayloadAction<number>) => {
            let id = action.payload
            let model: OTChargeModel = initialState.OTCharge
            if (id > 0) {
                let currentList: OTChargeModel[] = state.OTChargeList
                model = currentList.find((c) => c.Id === id) || initialState.OTCharge
            }

            state.OTCharge = model
        },
        deleteOTCharge: (state, action: PayloadAction<string>) => {
            let id: string = action.payload
            let ids: number[] = id.split(',').map((i) => parseInt(i))
            if (ids && ids.length > 0) {
                let currentList: OTChargeModel[] = state.OTChargeList
                state.OTChargeList = currentList.filter((c) => !ids.includes(c.Id))
            }
        },
    },
})

export const { setOTCharges, saveOTCharge, getOTChargeById, deleteOTCharge } =
    OTChargeSlice.actions

export default OTChargeSlice.reducer
